<template>
  <button
    type="button"
    class="flex w-full items-center justify-center"
    @click="onOpen"
  >
    <p class="mr-2"> More Actions </p>
    <IconVerticalEllipsis />
  </button>

  <BaseDrawer :is-open="isOpen" shrink @close="onClose">
    <div class="h-full overflow-y-auto p-4">
      <template v-if="showNetworkSettings">
        <ActionItemSmall
          label="WIFI Settings"
          :icon="IconWifi"
          :disabled="isDisabled"
          @click="INetworkSettings.openWifiSettings"
        />
        <ActionItemSmall
          label="Cellular Settings"
          :icon="IconCellular"
          :disabled="isDisabled"
          @click="INetworkSettings.openCellularSettings"
        />

        <div class="mt-2">
          <div
            class="mb-2 mt-4 h-px w-full bg-background-fg/8"
          />
        </div>
      </template>
      <ActionItemSmall
        label="Ignore & Skip Sync"
        :icon="IconExclamationTriangle"
        :disabled="isDisabled"
        color="warning"
        @click="onIgnore"
      />

      <ActionItemSmall
        label="Go Back"
        :icon="IconGoBack"
        :disabled="isDisabled"
        @click="onClose"
      />
    </div>
  </BaseDrawer>

  <BaseConfirmation
    ref="confirmIgnoreConfirmationRef"
    description="Please note, skipping this will mean that the payment is missing from your reporting"
    confirm-label="Ignore & Skip Sync"
    cancel-label="Go Back"
  />
</template>

<script setup lang="ts">
import { INetworkSettings } from "@/androidPlugins/INetworkSettings"

import {
  IconWifi,
  IconCellular,
  IconExclamationTriangle,
  IconGoBack,
  IconVerticalEllipsis,
} from "@/icons"

const props = defineProps<{
  isDisabled?: boolean
  showNetworkSettings?: boolean
}>()

const emit = defineEmits<{
  (event: "ignore"): void
}>()

const isOpen = ref(false)

const onOpen = () => (isOpen.value = true)
const onClose = () => (isOpen.value = false)

const confirmIgnoreConfirmationRef = useTemplateRef(
  "confirmIgnoreConfirmationRef"
)
const onIgnore = async () => {
  if (!confirmIgnoreConfirmationRef.value) return

  const { isCanceled } =
    await confirmIgnoreConfirmationRef.value.reveal()
  if (!isCanceled) {
    emit("ignore")
    onClose()
  }
}
</script>
